import './radio.style.sass';
import template from './radio.tpl.pug';

export default {
    selector: 'dbARadio',
    template: template(),
    bindings: {
        name: '@',
        selected: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/radio/radio.cmpt.js